import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Icon from "../../assets/icons/Icon";
import { posible_logo, logo } from "./../../config/imageImport";

import { fetchMenusTransaction } from "../../api/menuApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setInventoryTransactionType,
  setSalesTransactionType,
  setTransactionType,
} from "../../redux/slices/transactionTypeSlice";
import { ReportsData } from "./ReportsData";
import UserProfile from "../UserProfile";
import { selectRegistration, selectUser } from "../../redux/slices/userSlice";
import { useAcl } from "./CommonFunctions";
import Button from "./Button";
import PopupModal from "./PopupModal";
import InfoModal from "./InfoModal";

const Menu = ({ registaerationData }) => {
  const drawerRef = useRef(null);
 const userProfileRef = useRef(null);
  const {getVisibility}=useAcl();
  const [salesTransaction, setSalesTransaction] = useState([]);
  const [inventoryTransaction, setInventoryTransaction] = useState([]);
  const dispatch = useDispatch();
     const store = useSelector((state) => state.store.store);
  const isExpired = store?.NoOfDaysToExpire < 0 || false;

  const [isReportsSubMenuVisible, setIsReportsSubMenuVisible] = useState(false);
  const [activeReportSubMenu, setActiveReportSubMenu] = useState(null);

  const [showUserProfile, setShowUserProfile] = useState(false);
  const acl = useSelector((state) => state.acl.acl);
  const user = useSelector(selectUser);
  const registration = useSelector(selectRegistration)
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showOfflineBillingInfo,setShowOfflineBillingInfo]=useState(false);
    const [showOfflineBillingViewDetail,setShowOfflineBillingViewDetail]=useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    // Clear any existing timeout to prevent premature closing
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowOfflineBillingInfo(true);
  };
useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      setIsParentHovered(false);
      setShowSubMenu(false);
   
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      drawerRef.current &&
      !drawerRef.current.contains(event.target) &&
      userProfileRef.current &&
      !userProfileRef.current.contains(event.target)
    ) {
      setIsParentHovered(false);
      setShowSubMenu(false);
      setShowUserProfile(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const handleMouseLeave = () => {
    // Set a 10-second delay before hiding the element
    timeoutRef.current = setTimeout(() => {
      setShowOfflineBillingInfo(false);
    }, 10000); // 10 seconds in milliseconds
  };


  const {
    salesReports,
    inventoryReports,
    employeeReports,
    customerReports,
    vendorReports,
    expenseReports,
    loyaltyReports,
  } = ReportsData();

  //console.log("salesReports", salesReports)


  const showModule = (module, access = "read") => {
    if (!acl) return false;
    const modulePermission = acl.find(
      (e) => e.id == module
      //&& e.perms?.[access]
    );
    return !!modulePermission;
  };

  const getFilteredSalesTransactions = () => {
    return salesTransaction.filter((transaction) => {
      const shouldShowModule = showModule(transaction.TransactionType);

      if (registaerationData?.PincodeIntegration) {
        if (
          registaerationData.hasOwnProperty("PinocdeOrderTransactionTypeID") &&
          registaerationData.PinocdeOrderTransactionTypeID === transaction.key
        ) {
          return false;
        }
      }

      return (
        transaction.Module == "sales" &&
        !transaction.IsDeleted &&
        shouldShowModule
      );
    });
  };

  const getFilteredInventoryTransactions = () => {
    return inventoryTransaction.filter((transaction) => {
      const shouldShowModule = showModule(transaction.TransactionType);
      return (
        transaction.Module == "inventory" &&
        !transaction.IsDeleted &&
        shouldShowModule
      );
    });
  };

  // Main menu items with ACL checks
  const menuItems = [
    // ...(registration?.EnablePosBillingForPincode ? [{
    //   name: "Stockify",
    //   icon: "reports",
    //   subMenu: [{
    //     name: "Pace",
    //     icon: "reports",
    //     link: "https://order-fulfilment-pincode.matrix-prod-aps1.unifyapps.com/login?returnTo=%2F",
    //     external: true,
    //   }],
    // }] : []),

    // ...(registration?.EnablePincodeKirana ? [{
    //   name: "Stockify",
    //   icon: "reports",
    //   subMenu: [{
    //     name: "Pace",
    //     icon: "reports",
    //     link: "https://pace-pincode.matrix-prod-aps1.unifyapps.com/home",
    //     external: true,
    //   }],
    // }] : []),


    // Online Orders
    // showModule("Onlineorder") && {
    //   name: "Online Orders",
    //   icon: "order",
    //   subMenu: [{ name: "Online Order", icon: "order", link: "/onlineorders" }],
    // },

    // Sales menu
    (showModule("Sales") || getFilteredSalesTransactions().length > 0) && {
      name: "Sales",
      icon: "sales",
      subMenu: [
        // ...getFilteredSalesTransactions().map((transaction) => ({
        //   name: transaction.TransactionType,
        //   link: `/sales/salestransactionlist?type=${transaction.TransactionType}&transactionTypeId=${transaction.key}`,
        //   data: transaction,
        // })),
      
        {
          name: "Sales History",
          icon: "list",
          link: "/sales/salestransactionlist",
        },
       ( showModule("Deliverylist") || showModule("Onlineorder")) && {
          name: "Delivery List",
          icon: "list",
          link: "/sales/deliverylist",
        },
        
        showModule("CashRegistersClosing") && {
          name: "Cash Register Closing",
          icon: "cashregister",
          link: "/sales/cashregisterclosinglist",
        },
          registration?.KOT&&
                {
          name: "KOT - Kitchen Display",
          icon: "kds",
          link: "/sales/kds",
        },
          registration?.KOT&&
                {
          name: "KOT - Customer Display",
          icon: "kds",
          link: "/sales/kdscustomerdisplay",
        },
        showModule("Packages")&&{ name: "Packages", icon: "sales", link: "/packages"},
                {
          name: "Offline Billing",
          icon: "sales",
          type:"offlineBilling",
          link: "https://billing.posible.in/",
        },
      
      ].filter(Boolean),
    },

    // Inventory
    // (showModule("Inventory") ||
    //   getFilteredInventoryTransactions().length > 0) && {
      (showModule("Inventory"))&&{
      name: "Inventory",
      icon: "inventory",
      subMenu: [
   ...Object.values(getFilteredInventoryTransactions())
  .sort((a, b) => Number(a.SequenceNo) - Number(b.SequenceNo)).map((transaction) => ({
          name: transaction.TransactionType,
          link: `/inventory/inventorylist?type=${transaction.TransactionType}&transactionTypeId=${transaction.key}`,
          addIconClick:getVisibility(transaction.TransactionType,"create")  ? `/inventory/newinventory?type=${transaction.TransactionType}`: null,
          addIconState: {
            transactionType: transaction,
            type: "New"
          },
        })),
        {
          name: "Inventory list",
          icon: "list",
          link: "/inventory/inventorylist",
        },
        showModule("Intransit") && {
          name: "In transit",
          icon: "list",
          link: "/inventory/intransit",
        },
        showModule("Vendors") && {
          name: "Vendors",
          icon: "vendors",
          link: "/settings/vendors",
           addIconClick:getVisibility("Vendors","create")  ? `/settings/vendors/addvendors`: null,
   
        },
      ].filter(Boolean),
    },


    // CRM
    (showModule("Customers") ||
      showModule("Campaigns") ||
      showModule("Memberships") ||
      showModule("Coupons")) && {
      name: "CRM",
      icon: "crm",
      subMenu: [
              registration?.EnableCustomerInsight && {
          name: "Customers Dashboard",
          icon: "dashboard",
          link: "/crm/customerdashboard",
        },
        showModule("Customers") && {
          name: "Customers",
          icon: "customer",
          link: "/crm/customers",
        },
        showModule("Campaigns") && {
          name: "Campaigns",
          icon: "campaign",
          link: "/crm/campaigns",
        },
        showModule("Memberships") && {
          name: "Membership",
          icon: "membership",
          link: "/crm/memberships",
          addIconClick: getVisibility("Memberships", "create")
        ? "/crm/addmembership"
        : null
        },
        showModule("Coupons") && {
          name: "Coupons",
          icon: "coupon",
          link: "/crm/coupons",
          addIconClick:getVisibility("Coupons","create")  ? `/crm/addcoupon`: null,
        },
        showModule("MessageTemplate") && {
          name: "Message Template",
          icon: "sms",
          link: "/crm/message-template",
        },
      
     
      ].filter(Boolean),
    },



    // Loyalty
    showModule("LoyaltyDashboard") && {
      name: "Loyalty",
      icon: "loyalty",
      subMenu: [
        { name: "Loyalty Type", icon: "loyalty", link: "/loyalty/LoyaltyType",addIconClick:"/loyalty/add" },
        { name: "Setup", icon: "setup", link: "/loyalty/Setup" },
      ].filter(Boolean),
    },

    // Appointment
    showModule("Appointment") && {
      name: "Appointment",
      icon: "appointment",
      subMenu: [
        { name: "Appointment", icon: "appointment", link: "/appointment" },
      ],
    },

    // Expense
    (showModule("Expenses") ||
      showModule("AccountManagement") ||
      showModule("ExpenseCategories") ||
      showModule("Account")) && {
      name: "Expense",
      icon: "expense",
      subMenu: [
        { name: "Expense list", icon: "expense", link: "/expense/expenselist" },
        {
          name: "Account management",
          icon: "accountmanagement",
          link: "/expense/transactionlist",
        },
        showModule("ExpenseCategories") && {
          name: "Expense categories",
          icon: "expensecategories",
          link: "/expense/categorieslist",
        },
        { name: "account", icon: "account", link: "/expense/accounts" },
      ].filter(Boolean),
    },

    // Staff
    (showModule("Attendance") || showModule("Employees")) && {
      name: "Staff",
      icon: "staff",
      subMenu: [
        showModule("Attendance") && {
          name: "Attendance",
          icon: "attendance",
          link: "/staff/attendancelist",
        },
        showModule("Employees") && {
          name: "Staff details",
          icon: "staff",
          link: "/settings/employees/",
        },
      ].filter(Boolean),
    },

    // Online Store
    showModule("Onlinestore") && {
      name: "Online store",
      icon: "onlinestore",
      navigate:"https://posible-onlinestore-editor.web.app",
      external:true
    },

    // Catalogue
    (showModule("Products") ||
      showModule("Categories") ||
      showModule("Subcategories") ||
      showModule("Brands")) && {
      name: "Catalogue",
      icon: "catalogue",
      subMenu: [
        showModule("Products") && {
          name: "Product",
          icon: "product",
          link: "/catalogue/product",
           addIconClick:getVisibility("Products","create")  ? `/catalogue/product/Addproduct`: null,

        },
        showModule("Productquickedit") && {
          name: "Product - Quick Edit",
          icon: "product",
          link: "/catalogue/pincodeproductquickedit",
        },
        showModule("Aggregatorproducts") && {
          name: "Aggregator products",
          icon: "product",
          link: "/catalogue/product",
          addIconClick: "/catalogue/product/Addproduct",
        },

        showModule("ProductCategories") && {
          name: "Category",
          icon: "category",
          link: "/catalogue/category",
        },
        showModule("ProductCategories") && {
          name: "Subcategory",
          icon: "subcategory",
          link: "/catalogue/subcategory",
        },
        showModule("ProductBrands") && {
          name: "Brand",
          icon: "brand",
          link: "/catalogue/brands",
        },
        showModule("ProductTaxes") && {
          name: "Taxes",
          icon: "taxes",
          link: "/catalogue/taxes",
        },
        showModule("ProductTags") && {
          name: "Product group",
          icon: "vendors",
          link: "/catalogue/product-group",
        },
        showModule("Offers") && {
          name: "Offers",
          icon: "offers",
          link: "/catalogue/offers",
              addIconClick:getVisibility("Offers","create")  ? `/catalogue/offers/newoffer`: null,
        },

        showModule("BOM") && {
          name: "Bom",
          icon: "bom",
          link: "/catalogue/bom",
        },
      ].filter(Boolean),
    },

    // Setup
    showModule("Setup") && {
      name: "Setup",
      icon: "setup",
      subMenu: [
      {
          name: "Get Started",
          icon: "flash",
          link: "/setup/getstarted",
        },

        showModule("Newregistration") && {
          name: "New registration",
          icon: "registration",
          link: "/settings/registration",
        },
        showModule("Registration") && {
          name: "Registration",
          icon: "registration",
          link: "/settings/registration",
        },
        
        {
          name: "Sales Channel",
          icon: "customfields",
          link: "/setup/saleschannel",
        },
        
      (store?.hasOwnProperty("EnableTableOrder") &&
      store?.EnableTableOrder)
    &&
         {
          name: "Tables",
          icon: "table",
          link: "/setup/table",
        },
      

        showModule("Stores") && {
          name: "Stores",
          icon: "stores",
          link: "/settings/stores",
        },
        showModule("PaymentTypes") && {
          name: "Payment types",
          icon: "paymenttypes",
          link: "/settings/paymenttypes",
        },
        showModule("CustomRoles") && {
          name: "Custom roles",
          icon: "adduser",
          link: "/settings/customroles",
        },
        showModule("TransactionTypes") && {
          name: "Module configuration",
          icon: "moduleconfiguration",
          link: "/settings/moduleconfig",
        },
        showModule("CustomFields") && {
          name: "Custom fields",
          icon: "customfields",
          link: "/settings/customfields",
        },
        {
          name: "Transaction SMS template",
          icon: "sms",
          link: "/settings/transactionalsmstemplates",
        },
        showModule("Addtionalsettings") && {
          name: "Additional settings",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Pincodesettings") && {
          name: "Pincode settings",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Onboarding") && {
          name: "On Boarding",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        showModule("Tables") && {
          name: "Tables",
          icon: "setup",
          link: "/settings/addtionalsettings",
        },
        {
          name: "Integration",
          icon: "integration",
          link: "/integration",
        },
        { 
          name: "Payments",
          icon: "payment",
          link: "/payment/payment-options",
        },
      ].filter(Boolean),
    },

    // Reports
    showModule("Reports") && {
      name: "Reports",
      icon: "reports",
      subMenu: [
            showModule("NewDashboard") && {
          name: "Dashboard",
          icon: "dashboard",
          link: "/home",
        },
        showModule("Reports") && {
          name: "All Reports",
          icon: "reports",
          link: "/reports/allreports",
        },
        // showModule("SalesReports") &&
        salesReports.length > 0 && {
          name: "Sales Reports",
          icon: "sales",
          subMenuItems: salesReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("InventoryReports") &&
        inventoryReports.length > 0 && {
          name: "Inventory Reports",
          icon: "inventory",
          subMenuItems: inventoryReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("EmployeeReports") &&
        employeeReports.length > 0 && {
          name: "Employee Reports",
          icon: "staff",
          subMenuItems: employeeReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("CustomerReports") &&
        customerReports.length > 0 && {
          name: "Customer Reports",
          icon: "customer",
          subMenuItems: customerReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("VendorReports") &&
        vendorReports.length > 0 && {
          name: "Vendor Reports",
          icon: "vendors",
          subMenuItems: vendorReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("ExpenseReports") &&
        expenseReports.length > 0 && {
          name: "Expense Reports",
          icon: "expense",
          subMenuItems: expenseReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        // showModule("LoyaltyReports") &&
        loyaltyReports.length > 0 && {
          name: "Loyalty Reports",
          icon: "loyalty",
          subMenuItems: loyaltyReports.filter((report) => {
            // showModule(report.moduleId)
            return report;
          }
          ),
        },
        {
          name: "Downloaded Reports",
          icon: "download",
          link: "/reports/downloadedreports",
        },
      ].filter(Boolean),
    },

  ].filter(Boolean);

  // Rest of your component code remains the same...
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(menuItems[0]);
  const [isParentHovered, setIsParentHovered] = useState(false);
  const [activeSubmenuName, setActiveSubmenuName] = useState(null);
  const [activeSubmenuLink, setActiveSubmenuLink] = useState(null);

  useEffect(() => {
    const currentMenu = menuItems.find((menu) =>
      menu?.subMenu?.some(
        (subMenu) =>
          location.pathname.startsWith(subMenu.link?.split("?")[0]) ||
          (subMenu.addIconClick &&
            location.pathname.startsWith(subMenu.addIconClick)) ||
          (subMenu.subMenuItems &&
            subMenu.subMenuItems.some((item) =>
              location.pathname.startsWith(item.link?.split("?")[0])
            ))
      )
    );

    if (currentMenu) {
      setActiveMenu(currentMenu);

      currentMenu.subMenu.forEach((subMenu) => {
        if (subMenu.subMenuItems) {
          const activeInnerSub = subMenu.subMenuItems.find((item) =>
            location.pathname.startsWith(item.link?.split("?")[0])
          );
          if (activeInnerSub) {
            setActiveReportSubMenu(subMenu.name);
          }
        } else if (location.pathname.startsWith(subMenu.link?.split("?")[0])) {
          setActiveSubmenuName(subMenu.name);
          setActiveSubmenuLink(subMenu.link);
        } else if (
          subMenu.addIconClick &&
          location.pathname.startsWith(subMenu.addIconClick)
        ) {
          setActiveSubmenuName(subMenu.name);
          setActiveSubmenuLink(subMenu.addIconClick);
        }
      });
    }
  }, [location.pathname]);

  const isDrawerVisible = isParentHovered;
  const navigate = useNavigate();

  // const handleSetActiveMenu = (menu) => {
  //   setActiveMenu(menu);
  //   setShowUserProfile(false);
  //   if (menu.name === "reports") {
  //     setIsReportsSubMenuVisible(true);
  //   } else {
  //     setIsReportsSubMenuVisible(false);
  //     setActiveReportSubMenu(null);
  //   }
  // };

const handleSetActiveMenu = (menu) => {
  setShowUserProfile(false);

   if ( menu?.external) {
    window.open(menu?.navigate, '_blank');
    setShowSubMenu(false);
    setIsParentHovered(false);
    // Set the menu as active even for external links
    setActiveMenu(menu);
    return;
  }
  const subMenus = menu?.subMenu || [];

  // Handle external links
  if (subMenus.length === 1 && subMenus[0]?.external) {
    window.open(subMenus[0].link, '_blank');
    setShowSubMenu(false);
    setIsParentHovered(false);
    // Set the menu as active even for external links
    setActiveMenu(menu);
    return;
  }

  // Handle single submenu items
  if (subMenus.length === 1 && subMenus[0]?.link) {
    navigate(subMenus[0].link);
    setShowSubMenu(false);
    setIsParentHovered(false);
    // Set the menu as active
    setActiveMenu(menu);
    return;
  }

  // For menus with multiple submenus
  setActiveMenu(menu);
  setShowSubMenu(true);
  if (menu.name === "reports") {
    setIsReportsSubMenuVisible(true);
  } else {
    setIsReportsSubMenuVisible(false);
    setActiveReportSubMenu(null);
  }
};


  const handleReportSubMenuClick = (subMenuName) => {
    setActiveReportSubMenu(
      activeReportSubMenu === subMenuName ? null : subMenuName
    );
  };

  const fetchMenus = async () => {
    try {
      const response = await fetchMenusTransaction();
      dispatch(setTransactionType(response.transactionTypes));
      const dataForSales = response.transactionTypes.filter(
        (transaction) =>
          !transaction.IsDeleted && transaction.Module === "sales"
      );
      setSalesTransaction(dataForSales);
      dispatch(setSalesTransactionType(dataForSales));
      const dataForInventory = response.transactionTypes.filter(
        (transaction) =>
          !transaction.IsDeleted && transaction.Module === "inventory"
      );
      setInventoryTransaction(dataForInventory);
      dispatch(setInventoryTransactionType(dataForInventory));
    } catch (err) {
      console.log(err, "while fetching the menu data");
    }
  };

  useEffect(() => {
    // console.log("acl", acl);

    fetchMenus();
  }, [acl]);
  //   useEffect(() => {
  //   if (!showSubMenu) {
  //     setShowUserDetails(false);
  //   }
  // }, [showSubMenu]);
  return (
    <>

      <div ref={drawerRef} className="relative bg-yellow-100">
        {/* Main menu */}
        <div
          className={`h-screen bg-black relative overflow-y-auto  custom-scrollable z-50 flex  w-18 flex-col py-3`}
          onClick={() => setIsParentHovered(true)}
        // onMouseLeave={() => {
        //   setIsParentHovered(false);
        //   setShowUserProfile(false);
        // }}
        >
          {/* Logo */}
          <div className="flex flex-col items-center mt-2 mb-2">
            <img
              onClick={() => {
                navigate("/home");
                // Find the Dashboard menu item
                const dashboardMenu = menuItems.find(menu =>
                  menu.subMenu?.some(sub => sub.name === "Dashboard")
                );
                if (dashboardMenu) {
                  // Set the active menu without opening the drawer
                  setActiveMenu(dashboardMenu);
                  setShowSubMenu(false); // Explicitly close the submenu
                  setIsParentHovered(false); // Ensure drawer stays closed
                }
              }}
              src={logo}
              alt="Logo"
              className={`w-10
                } h-auto transition-all duration-300 cursor-pointer`}
            />
          </div>

          {/* Menu Items */}
         {!isExpired && <div className="flex-1  space-y-1">
            {menuItems
              .filter(menu => menu.name !== "Setup") // Hide "Steup" menu
              .map((menu, index) => (
                <div
                  key={index}
                  className={`w-full cursor-pointer text-gray-400 hover:text-gray-100 py-2 px-8.5 gap-1 flex flex-col items-center ${activeMenu?.name === menu?.name && !showUserProfile
                      ? "border-l-4 bg-gradient-to-r text-white from-[#b01dff]/40 to-[#af62d6]/10 border-[#a416f1]"
                      : "border-transparent border-r-2 border-l-2"
                    }`}
                  onClick={() => handleSetActiveMenu(menu)}
                >
                  <span className="w-4.5">
                    <Icon type={menu.icon} />
                  </span>
                  <h1
                    className={`text-nowrap text-[10px]`}
                  >
                    {menu?.name}
                  </h1>
                </div>
              ))}
          </div>}

          {/* Profile Icon */}
          {(menuItems.find((item) => item.name === "Setup") && !isExpired) && <div className={`px-4 mt-3 flex justify-center`}>

            <div
              className={`w-full cursor-pointer text-gray-400 hover:text-gray-100 py-2 px-8.5
                } gap-1 flex flex-col items-center ${activeMenu?.name === "Setup" && !showUserProfile
                  ? "border-l-4 bg-gradient-to-r text-white from-[#b01dff]/40 to-[#af62d6]/10 border-[#a416f1]"
                  : "border-transparent border-r-2 border-l-2"
                }`}
              onClick={() => {
                const Setup = menuItems.find((item) => item.name === "Setup");
                handleSetActiveMenu(Setup);
              }}
            >
              <span className="w-4.5">
                <Icon type={"setup"} />
              </span>
              <h1
                className={` text-nowrap text-[10px]`}
              >
                {"Setup"}
              </h1>
            </div>
          </div>}
          <div className={`px-4 mt-3`}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                setShowUserProfile(!showUserProfile);
                setIsParentHovered(false);
                setActiveMenu(null);
                // menuItems[0]
              }}
              className={`rounded-full cursor-pointer ${showUserProfile ? "bg-[#a416f1] text-white" : "bg-white text-gray-500"
                } p-1.5 w-9`}
            >
              <Icon type="user" />
            </div>
          </div>
        </div>

        {/* Submenu */}
        {activeMenu && !showUserProfile && showSubMenu && (
          <div
            className={`absolute overflow-y-auto custom-scrollable pb-10 bg-[#0D111A] border-l-1 border-gray-700 h-screen top-0 w-70 z-40 transition-all duration-300 ease-in-out ${isDrawerVisible
                ? "translate-x-16 opacity-100"
                : "-translate-x-full opacity-0"
              } ${isDrawerVisible ? "visible" : "invisible delay-100"}`}
            onMouseLeave={() => {
              // setShowSubMenu(false)
              // setIsParentHovered(false)
              // setShowUserProfile(false);


            }}
          >
            <div className="px-2 w-full">
              <div className="pt-4 w-full flex items-center">
             
                <div
                  className="w-7 flex items-center justify-center text-white/50 hover:text-white/80 cursor-pointer ml-auto mr-5"
                  onClick={() => {
                    setIsParentHovered(false);
                  }}

                >
                  <Icon type="remove" />
                </div>
              </div>

              {/* Submenu Title */}
              <div className="relative px-1 my-6">
                <h1 className="capitalize mb-1 text-gray-100 text-base font-bold">
                  {activeMenu?.name}
                </h1>
                <div className="w-5 h-0.5 bg-[#a416f1]"></div>
              </div>

              {/* Submenu List */}
              <div className="grid gap-1.5">
                {activeMenu.subMenu.map((subMenu, index) => {
                  if (subMenu.external) {
                    return (
                      <a
                        key={index}
                        href={subMenu.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex gap-3 text-gray-200 cursor-pointer transition-all duration-200 px-2.5 py-2 rounded-md hover:bg-[#2b334576]"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(subMenu.link, '_blank');
                          setIsParentHovered(false);
                          setShowUserProfile(false);
                        }}
                      >
                        {subMenu.icon && (
                          <span className="w-5">
                            <Icon type={subMenu.icon} />
                          </span>
                        )}
                        <h1 className="first-letter:uppercase text-sm">
                          {subMenu.name}
                        </h1>
                      </a>
                    );
                  }
                  if (subMenu.subMenuItems) {
                    return (
                      <div key={index}>
                        <div
                          className={`flex gap-3 text-gray-200 cursor-pointer transition-all duration-200 px-2.5 py-2 rounded-md ${activeReportSubMenu === subMenu.name
                            ? "bg-[#242b3b]"
                            : "hover:bg-[#2b334576]"
                            }`}
                          onClick={() => handleReportSubMenuClick(subMenu.name)}
                        >
                          {subMenu.icon && (
                            <span className="w-5">
                              <Icon type={subMenu.icon} />
                            </span>
                          )}
                          <h1 className="first-letter:uppercase text-sm font-semibold">
                            {subMenu.name}
                          </h1>
                          <span className="ml-auto">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className={`h-4 w-4 ${activeReportSubMenu === subMenu.name ? "rotate-90" : ""
                                }`}
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </span>
                        </div>

                        {activeReportSubMenu === subMenu.name && (
                          <div className="ml-6 grid gap-1 mt-1 mb-2">
                            {subMenu.subMenuItems.map((item, i) => (
                              <NavLink
                                to={item.link}
                                key={i}
                                className={`flex gap-3 border-b-1 border-gray-800 hover:border-1 text-gray-200 cursor-pointer transition-all duration-200 px-2.5 py-2 rounded-md hover:bg-[#2b334576]`}
                                onClick={() => {
                                  setIsParentHovered(false);
                                  setShowUserProfile(false);
                                }}
                              >
                                {item.icon && (
                                  <span className="w-5">
                                    <Icon type={item.icon} />
                                  </span>
                                )}
                                <h1 className="first-letter:uppercase text-xs text-gray-300">
                                  {item.name}
                                </h1>
                              </NavLink>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    // Handling simple submenu
                    const isTransactionType = subMenu.link?.includes("type=");
                    const isInventoryList =
                      subMenu.name?.toLowerCase() === "inventory list";
                    const isSalesHistory =
                      subMenu.name?.toLowerCase() === "sales history";

                    let isActive = false;

                    if (isTransactionType) {
                      const urlParams = new URLSearchParams(location.search);
                      const typeParam = urlParams.get("type");
                      const transactionTypeIdParam = urlParams.get("transactionTypeId");

                      isActive =
                        location.pathname.startsWith(subMenu.link?.split("?")[0]) &&
                        typeParam === subMenu.data?.TransactionType &&
                        transactionTypeIdParam === subMenu.data?.key;
                    } else if (isInventoryList) {
                      const urlParams = new URLSearchParams(location.search);
                      const typeParam = urlParams.get("type");
                      const transactionTypeIdParam = urlParams.get("transactionTypeId");

                      isActive =
                        location.pathname.startsWith(subMenu.link?.split("?")[0]) &&
                        !typeParam &&
                        !transactionTypeIdParam;
                    } else {
                      isActive =
                        location.pathname.startsWith(subMenu.link?.split("?")[0]) ||
                        (subMenu.addIconClick &&
                          location.pathname.startsWith(subMenu.addIconClick));
                    }

                    return (
                      <NavLink
                        // to={{
                        //   pathname: subMenu.link?.split("?")[0],
                        //   search: subMenu.link?.includes("?")
                        //     ? `?${subMenu.link?.split("?")[1]}`
                        //     : "",
                        //   ...(subMenu?.data && {
                        //     state: { data: subMenu.data },
                        //   }),
                        // }}
                          {...(subMenu?.type !== "offlineBilling" && {
    to: {
      pathname: subMenu.link?.split("?")[0],
      search: subMenu.link?.includes("?")
        ? `?${subMenu.link?.split("?")[1]}`
        : "",
      ...(subMenu?.data && { state: { data: subMenu.data } }),
    },
  })}
                        key={index}
                        className={`${subMenu?.type=="offlineBilling" ?"flex-col":"flex"} gap-3 text-gray-200 cursor-pointer transition-all duration-200 px-2.5 py-2 rounded-md ${isActive ? "bg-[#242b3b]" : "hover:bg-[#2b334576]"
                          }`}
                        onClick={() => {
                          
                          console.log("parent calling");
                          setIsParentHovered(false);
                          setShowUserProfile(false);
                   
                          setActiveSubmenuName(subMenu.name);
                          setActiveSubmenuLink(subMenu.link);
                          
                        }}
                      >
                        {subMenu?.type=="offlineBilling" &&
                        <>
                        <span   onMouseEnter={()=>{handleMouseEnter()}}
        onMouseLeave={()=>{handleMouseLeave()}}>
                        <Button type="primary"      onClick={(e) => {
                          e.preventDefault();
                          window.open(subMenu.link, '_blank');
                          setIsParentHovered(false);

                        
                        }} showFullWidth={true} iconType={"sales"}>{subMenu.name}</Button>
                        </span>

                   <div onClick={()=>{ }}   onMouseEnter={()=>{handleMouseEnter()}}  onMouseLeave={()=>{handleMouseLeave()}} className="mt-5 w-full text-sm"> Our offline billing feature allows you to continue your business operations seamlessly even when internet connectivity is unavailable. <span className="text-blue-400 cursor-pointer hover:text-blue-300" onClick={()=>{setShowOfflineBillingViewDetail(true)}}>View details</span></div>
                   
                        </>
                  }
                      {subMenu?.type!=="offlineBilling" && <> {subMenu.icon && (
                          <span className="w-5">
                            <Icon type={subMenu.icon} />
                          </span>
                        )}
                        <h1 className="first-letter:uppercase text-sm">
                          {subMenu.name}
                        </h1>
                        {subMenu.addIconClick && (
                          <span
                            className="ml-auto"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setActiveSubmenuName(subMenu.name);
                              setActiveSubmenuLink(subMenu.addIconClick);
                              navigate(subMenu.addIconClick, {
                                state: subMenu.addIconState
                              });
                              setIsParentHovered(false);
                              setShowUserProfile(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 mr-2"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 4v16m8-8H4"
                              />
                            </svg>
                          </span>
                        )}</>}
                      </NavLink>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        )}
      </div>
 {showOfflineBillingViewDetail &&
 <InfoModal
  setPopUp={setShowOfflineBillingViewDetail}
  type={"OfflineBilling"}
 />
//  <PopupModal
//           setPopUp={setShowOfflineBillingViewDetail}
//           size="w-[30vw] max-h-[95vh]"
//           saveClick={()=>{}}
//           handleClose={()=>{}}
//           buttons={false}
       
//           title={"Why Use Offline Billing ?"}
//         >
//           <ul class="list-disc ml-6 space-y-2 text-sm leading-relaxed">
//   <li>Lets you continue billing customers even if your internet goes down.</li>
//   <li>Bills are saved safely on your computer/device.</li>
//   <li>As soon as the internet comes back, all bills automatically sync to the server.</li>
//   <li>No waiting for internet – keep serving customers without interruption.</li>
//   <li>Prevents loss of sales during network issues.</li>
//   <li>Works seamlessly – the shop owner doesn’t need to do anything extra.</li>
//   <li>Just click “Offline Billing” when you don’t have internet.</li>
//   <li>Continue making bills as usual while offline.</li>
//   <li>Once internet is restored, the system automatically uploads all bills to the server.</li>
//   <li>Example: If your shop Wi-Fi stops working while billing, you can still create bills and they’ll sync later when online.</li>
// </ul>
// </PopupModal>
}

     {showUserProfile && (
  <div ref={userProfileRef}>
    <UserProfile
      onClose={() => {
        setShowUserProfile(false);
      }}
    />
  </div>
)}
    </>
  );
};

export default Menu;